<!-- App.vue -->
<template>
  <div id="app" style="height: 100%;">
    <loginPage 
      :baseurl="baseurl" 
      v-if="currentPage === 'login'" 
      @login-success="handleLoginSuccess"
    />
    
    <qbDetails 
      :baseurl="baseurl" 
      v-else-if="currentPage === 'notes'" 
      @logout="handleLogout"
    />
    
    <el-dialog 
      v-if="showAnnouncementDialog && latestAnnouncement"
      title="系统公告"
      :visible.sync="showAnnouncementDialog"
      close-on-press-escape
      width="80%"
      :close-on-click-modal="false"
      lock-scroll
      custom-class="announcement-dialog"
    >
      <div>
        <div class="announcement-header">
          <h3>{{ latestAnnouncement.title }}</h3>
          <div class="meta-info">
            发布时间: {{ formatTime(latestAnnouncement.created_at) }}
          </div>
        </div>
        
        <div class="announcement-divider"></div>
        <div class="content" v-html="latestAnnouncement.content"></div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAnnouncementDialog = false">关闭</el-button>
        <el-button type="primary" @click="viewHistoryAnnouncements">查看历史公告</el-button>
      </div>
    </el-dialog>
    
    <el-dialog 
      title="历史公告"
      close-on-press-escape	
      lock-scroll
      :visible.sync="showHistoryDialog"
      custom-class="announcement-dialog"
      width="80%"
      :close-on-click-modal="false"
    >
      <el-table :data="historyAnnouncements" border style="width: 100%">
        <el-table-column prop="title" label="标题" min-width="200" />
        <el-table-column 
          prop="created_at" 
          label="发布时间" 
          width="180"
          :formatter="formatTableTime"
        />
        <el-table-column label="操作" align="center" fixed="right" width="70">
          <template slot-scope="scope">
            <div
              style="cursor: pointer; color: #1677ff; border: 1px solid #1677ff; border-radius: 4px; padding: 2px 8px; font-size: 13px;"
              type="text" 
              @click="viewAnnouncementDetail(scope.row)"
            >
              查看
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPageNum"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="totalAnnouncements"
        style="margin-top: 20px; text-align: right;"
      />
    </el-dialog>
      
    <el-dialog 
      title="公告详情"
      :visible.sync="showDetailDialog"
      width="80%"
      custom-class="announcement-dialog"
    >
      <div v-if="currentAnnouncement">
        <h3>{{ currentAnnouncement.title }}</h3>
        <div class="meta-info">
          发布时间: {{ formatTime(currentAnnouncement.created_at) }} |
          状态: {{ currentAnnouncement.is_active ? '启用' : '禁用' }}
        </div>
        <hr>
        <div class="content" v-html="currentAnnouncement.content"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import loginPage from './components/loginPage.vue'
import qbDetails from './components/qbDetails.vue'

export default {
  name: 'App',
  components: {
    loginPage,
    qbDetails
  },
  data() {
    return {
      currentPage: 'login',
      // baseurl: 'http://localhost:3000/api',
      baseurl: 'api/api',

      latestAnnouncement: null,
      showAnnouncementDialog: false,
      showHistoryDialog: false,
      showDetailDialog: false,
      historyAnnouncements: [],
      currentAnnouncement: null,
      currentPageNum: 1,
      pageSize: 10,
      totalAnnouncements: 0
    }
  },
  created() {
    this.checkAuth()
  },
  async mounted() {
    if (this.currentPage === 'login') {
      await this.getLatestAnnouncement()
    }
  },
  methods: {
    async checkAuth() {
      try {
        const response = await fetch(`${this.baseurl}/check`, {
          credentials: 'include'
        })
        const data = await response.json()
        
        if (data.success) {
          this.currentPage = 'notes'
        } else {
          await this.getLatestAnnouncement()
        }
      } catch (error) {
        await this.getLatestAnnouncement()
      }
    },
    
    async getLatestAnnouncement() {
      try {
        const response = await fetch(`${this.baseurl}/announcements/latest`, {
          credentials: 'include'
        })
        const data = await response.json()
        
        if (data.success && data.data) {
          this.latestAnnouncement = data.data
          this.showAnnouncementDialog = true
        }
      } catch (error) {
        console.error('获取最新公告失败:', error)
      }
    },
    
    async getHistoryAnnouncements() {
      try {
        const response = await fetch(
          `${this.baseurl}/announcements/history?page=${this.currentPageNum}&pageSize=${this.pageSize}`,
          { credentials: 'include' }
        )
        const data = await response.json()
        
        if (data.success) {
          this.historyAnnouncements = data.data.list
          this.totalAnnouncements = data.data.total
        }
      } catch (error) {
        console.error('获取历史公告失败:', error)
      }
    },
    
    viewHistoryAnnouncements() {
      this.showAnnouncementDialog = false
      this.showHistoryDialog = true
      this.getHistoryAnnouncements()
    },
    
    viewAnnouncementDetail(announcement) {
      this.currentAnnouncement = announcement
      this.showDetailDialog = true
    },
    
    formatTime(timeStr) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    
    formatTableTime(row) {
      return this.formatTime(row.created_at)
    },
    
    handleSizeChange(val) {
      this.pageSize = val
      this.getHistoryAnnouncements()
    },
    handleCurrentChange(val) {
      this.currentPageNum = val
      this.getHistoryAnnouncements()
    },
    
    handleLoginSuccess() {
      this.currentPage = 'notes'
      this.showAnnouncementDialog = false
    },
    
    handleLogout() {
      this.currentPage = 'login'
      this.getLatestAnnouncement()
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.content {
  max-height: 350px;
  overflow-y: auto;
  line-height: 1.8;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #1d2129;
}

.meta-info {
  color: #86909c;
  font-size: 13px;
  margin: 10px 0;
}

.announcement-header h3 {
  color: #1d2129;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.announcement-divider {
  height: 1px;
  background: #e5e6eb;
  margin: 16px 0;
}

:deep(.el-dialog__body) {
  padding: 16px 20px;
}

:deep(.announcement-dialog) {
  border-radius: 8px;
  border: 1px solid #e5e6eb;
}

:deep(.announcement-dialog .el-dialog__header) {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #e5e6eb;
}

:deep(.announcement-dialog .el-dialog__title) {
  color: #1d2129;
  font-weight: 600;
  font-size: 16px;
}

:deep(.announcement-dialog .el-dialog__headerbtn) {
  top: 18px;
}

:deep(.announcement-dialog .el-dialog__headerbtn .el-dialog__close) {
  color: #86909c;
}

:deep(.announcement-dialog .el-dialog__headerbtn:hover .el-dialog__close) {
  color: #1d2129;
}

:deep(.announcement-dialog .el-dialog__footer) {
  padding: 12px 20px 16px;
  border-top: 1px solid #f2f3f5;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

:deep(.announcement-dialog .el-button) {
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 13px;
  transition: all 0.2s ease;
}

:deep(.announcement-dialog .el-button:not(.el-button--primary)) {
  border: 1px solid #d0d3d9;
  color: #4e5969;
  background: #fff;
}

:deep(.announcement-dialog .el-button:not(.el-button--primary):hover) {
  border-color: #1677ff;
  color: #1677ff;
}

:deep(.announcement-dialog .el-button--primary) {
  background: #1677ff;
  border: none;
}

:deep(.announcement-dialog .el-button--primary:hover) {
  background: #4096ff;
}

:deep(.el-table) {
  font-size: 14px;
}

:deep(.el-table th.el-table__cell) {
  text-align: center !important;
  padding: 0 !important;
  background: #f7f8fa !important;
  line-height: 36px;
}

:deep(.el-table .cell) {
  text-align: center !important;
  padding: 0 4px !important;
  line-height: 30px !important;
  height: 30px;
  font-size: 14px;
}

@media (max-width: 768px) {
  :deep(.announcement-dialog) {
    width: 90% !important;
    margin-top: 10vh !important;
  }
  
  :deep(.announcement-dialog .el-dialog__body) {
    padding: 12px 16px;
  }
  
  .announcement-header h3 {
    font-size: 15px;
  }
  
  .content {
    max-height: 300px;
  }
  
  .dialog-footer {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  :deep(.announcement-dialog .el-button) {
    flex: 1;
    min-width: 100px;
  }
}
</style>